import {styled} from "@reside/ui";
import {Footer} from "../../footer";
import {Column} from "../block-slide/BlockSlide";

export const SignAdmissionFooter = styled(Footer)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const FullHeightColumn = styled(Column)`
  height: 100%;
`;
